// ColumnHeaderWithSearch.js
import { TextField, InputAdornment, Box, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import React from 'react';

const ColumnHeaderWithSearch = ({ title, value, onChange, align = 'center' }) => (
  <Box display="flex" flexDirection="column" sx={{ width: '100%' }}>
    <Typography 
      variant="subtitle2" 
      sx={{ 
        fontWeight: 600,
        fontSize: '0.875rem',
        textTransform: 'none !important',
        mb: 0.5,
        color: 'text.primary',
        textAlign: align
      }}
    >
      {title}
    </Typography>
    <TextField
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      variant="standard"
      size="small"
      placeholder="Search"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" />
          </InputAdornment>
        ),
      }}
      sx={{
        '& .MuiInputBase-input': {
          fontSize: '0.75rem',
        }
      }}
    />
  </Box>
);

export default ColumnHeaderWithSearch;
